export default class TravelPlanV1ViewModel {
    version: string | null = null;
    implementationMonth: number | null = null;
    implementationYear: number | null = null;
    accreditedOrRewardedForQuality: string | null = null;
    travelPlanCoordinator: string | null = null;
    coordinatorShiftType: string | null = null;
    targetGroupStaff: string | null = null;
    targetGroupVisitors: string | null = null;
    targetGroupCustomers: string | null = null;
    targetGroupStudents: string | null = null;
    targetGroupPatients: string | null = null;
    targetGroupAllSiteUsers: string | null = null;
    targetGroupOtherUsers: string | null = null;
    targetGroupOtherSpecify: string | null = null;
    type: string | null = null;
    typeOtherSpecify: string | null = null;
    additionalFeaturesComment: string | null = null;
    changesFromPreviousSurveysComment: string | null = null;
    modalSplitObtainedBeforeTravelPlan: string | null = null;
    modalSplitMonth: number | null = null;
    modalSplitYear: number | null = null;
    modalSplitVehicles: number | null = null;
    modalSplitCyclists: number | null = null;
    modalSplitPublicTransport: number | null = null;
    modalSplitPedestrians: number | null = null;
    percentageVehicles: number | null = null;
    percentageCyclists: number | null = null;
    percentagePublicTransport: number | null = null;
    percentagePublicPedestrians: number | null = null;
    modeSplitTargetsIdentified: string | null = null;
    modeSplitTargetsIdentifiedMonth: number | null = null;
    modeSplitTargetsIdentifiedYear: number | null = null;
    travelPlanTargetComment: string | null = null;
    largeScaleChangeInStaffNumbers: string | null = null;
    changeInSiteFunction: string | null = null;
    parkingControlsChanged: string | null = null;
    largeScaledChangesInPublicTransportServices: string | null = null;
    LargeScaledChangesInPublicTransportServicesComment: string | null = null;
    siteRelocatedToPlaceWithDifferingAccessiility: string | null = null;
    detailsOfFactorsAffectingTripRates: string | null = null;
    additionalCommentsOnTravelPlan: string | null = null;
    coveredCycleRacksCloseToBuildingEnterance: string | null = null;
    coveredCycleRacksCloseToBuildingEnteranceDate: Date | null = null;
    coveredCycleRacksCloseToBuildingEnteranceCapitalCost: number | null = null;
    coveredCycleRacksCloseToBuildingEnteranceAnnulaCost: number | null = null;
    goodLightingInCycleParkingAreas: string | null = null;
    goodLightingInCycleParkingAreasDate: Date | null = null;
    goodLightingInCycleParkingAreasCapitalCost: number | null = null;
    goodLightingInCycleParkingAreasAnnualCost: number | null = null;
    lockersAndFacilitiesForStaffCycling: string | null = null;
    lockersAndFacilitiesForStaffCyclingDate: Date | null = null;
    lockersAndFacilitiesForStaffCyclingCapitalCost: number | null = null;
    lockersAndFacilitiesForStaffCyclingAnnualCost: number | null = null;
    secureWellLitOrCoveredCycleParking: string | null = null;
    secureWellLitOrCoveredCycleParkingDate: Date | null = null;
    secureWellLitOrCoveredCycleParkingCapitalCost: number | null = null;
    secureWellLitOrCoveredCycleParkingAnnualCost: number | null = null;
    cctvCoverageOfCycleArea: string | null = null;
    cctvCoverageOfCycleAreaDate: Date | null = null;
    cctvCoverageOfCycleAreaCapitalCost: number | null = null;
    cctvCoverageOfCycleAreaAnnualCost: number | null = null;
    showersAndChangingFacilitiesForStaff: string | null = null;
    showersAndChangingFacilitiesForStaffDate: Date | null = null;
    showersAndChangingFacilitiesForStaffCapitalCost: number | null = null;
    showersAndChangingFacilitiesForStaffAnnualCost: number | null = null;
    goodNetworkOfCycleRoutesLinkedToSite: string | null = null;
    goodNetworkOfCycleRoutesLinkedToSiteDate: Date | null = null;
    goodNetworkOfCycleRoutesLinkedToSiteCapitalCost: number | null = null;
    goodNetworkOfCycleRoutesLinkedToSiteAnnualCost: number | null = null;
    cycleComments: string | null = null;
    matchingSystemForCarSharing: string | null = null;
    matchingSystemForCarSharingDate: Date | null = null;
    matchingSystemForCarSharingCapitalCost: number | null = null;
    matchingSystemForCarSharingAnnualCost: number | null = null;
    guaranteedFreeRideHomeForEmergencies: string | null = null;
    guaranteedFreeRideHomeForEmergenciesDate: Date | null = null;
    guaranteedFreeRideHomeForEmergenciesCapitalCost: number | null = null;
    guaranteedFreeRideHomeForEmergenciesAnnualCost: number | null = null;
    priorityParkingSpacesForCarSharers: string | null = null;
    priorityParkingSpacesForCarSharersDate: Date | null = null;
    priorityParkingSpacesForCarSharersCaptialCost: number | null = null;
    priorityParkingSpacesForCarSharersAnnualCost: number | null = null;
    localCarClubAvailable: string | null = null;
    siteOperatedOrIndependantCarClubAvailable: string | null = null;
    carSharingComments: string | null = null;
    limitedAvailabilityOfOnSiteSpaces: string | null = null;
    parkingPermitEligibilityRestrictions: string | null = null;
    parkingPermitEligibilityRestrictionsDate: Date | null = null;
    parkingPermitEligibilityRestrictionsCapitalCost: number | null = null;
    parkingPermitEligibilityRestrictionsAnnualCost: number | null = null;
    parkingChargesForParticularGroup: string | null = null;
    parkingChargesForParticularGroupDate: Date | null = null;
    parkingChargesForParticularGroupCapitalCost: number | null = null;
    parkingChargesForParticularGroupAnnualCost: number | null = null;
    parkingChargesForParticularGroupCharge: number | null = null;
    parkingChargesForParticularGroupPeriod: string | null = null;
    parkingEnforcementMeasuresInPlace: string | null = null;
    parkingEnforcementMeasuresInPlaceDate: Date | null = null;
    parkingEnforcementMeasuresInPlaceCapitalCost: number | null = null;
    parkingEnforcementMeasuresInPlaceAnnualCost: number | null = null;
    parkingComments: string | null = null;
    dailyPaymentOrCashOutAvailable: string | null = null;
    dailyPaymentOrCashOutAvailableDate: Date | null = null;
    dailyPaymentOrCashOutAvailableCapitalCost: number | null = null;
    dailyPaymentOrCashOutAvailableAnnualCost: number | null = null;
    dailyPaymentOrCashOutAvailableDailyPayment: number | null = null;
    annualPaymentToGiveUpParkingPermit: string | null = null;
    annualPaymentToGiveUpParkingPermitDate: Date | null = null;
    annualPaymentToGiveUpParkingPermitCapitalCost: number | null = null;
    annualPaymentToGiveUpParkingPermitAnnualCost: number | null = null;
    annualPaymentToGiveUpParkingPermitAnnualPayment: number | null = null;
    seasonTicketOrCycleLoanAvailable: string | null = null;
    seasonTicketOrCycleLoanAvailableDate: Date | null = null;
    seasonTicketOrCycleLoanAvailableCapitalCost: number | null = null;
    seasonTicketOrCycleLoanAvailableAnnualCost: number | null = null;
    seasonTicketOrCycleLoanAvailableAnnualLoanAmount: number | null = null;
    financialIncetivesComments: string | null = null;
    coveredBusShelterWithin400mOfSite: string | null = null;
    coveredBusShelterWithin400mOfSiteDate: Date | null = null;
    coveredBusShelterWithin400mOfSiteCapitalCost: number | null = null;
    coveredBusShelterWithin400mOfSiteAnnualCost: number | null = null;
    newOrImprovedBusServicesClosetoSite: string | null = null;
    newOrImprovedBusServicesClosetoSiteDate: Date | null = null;
    newOrImprovedBusServicesClosetoSiteCapitalCost: number | null = null;
    newOrImprovedBusServicesClosetoSiteAnnualCost: number | null = null;
    pedestrianRoutesToRailwayStations400m: string | null = null;
    pedestrianRoutesToRailwayStations400mDate: Date | null = null;
    pedestrianRoutesToRailwayStations400mCapitalCost: number | null = null;
    pedestrianRoutesToRailwayStations400mAnnualCost: number | null = null;
    pedestrianRoutesToRailwayStations1000m: string | null = null;
    pedestrianRoutesToRailwayStations1000mDate: Date | null = null;
    pedestrianRoutesToRailwayStations1000mCapitalCost: number | null = null;
    pedestrianRoutesToRailwayStations1000mAnnualCost: number | null = null;
    transportInfoProvidedOnsite: string | null = null;
    transportInfoProvidedOnsiteDate: Date | null = null;
    transportInfoProvidedOnsiteCapitalCost: number | null = null;
    transportInfoProvidedOnsiteAnnualCost: number | null = null;
    publicityAndAwarenessMaterial: string | null = null;
    publicityAndAwarenessMaterialDate: Date | null = null;
    publicityAndAwarenessMaterialCapitalCost: number | null = null;
    publicityAndAwarenessMaterialAnnualCost: number | null = null;
    personalisedPlanningOrTravelAssistance: string | null = null;
    personalisedPlanningOrTravelAssistanceDate: Date | null = null;
    personalisedPlanningOrTravelAssistanceCapitalCost: number | null = null;
    personalisedPlanningOrTravelAssistanceAnnualCost: number | null = null;
    publicTransportComments: string | null = null;
    shuttleBusServiceToResidentialAreas: string | null = null;
    shuttleBusServiceToResidentialAreasDate: Date | null = null;
    shuttleBusServiceToResidentialAreasCapitalCost: number | null = null;
    shuttleBusServiceToResidentialAreasAnnualCost: number | null = null;
    shuttleBusServiceToStations: string | null = null;
    shuttleBusServiceToStationsDate: Date | null = null;
    shuttleBusServiceToStationsCapitalCost: number | null = null;
    shuttleBusServiceToStationsAnnualCost: number | null = null;
    shuttleBusServiceComments: string | null = null;
}